var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-online-user-activity-349808 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9969 18.0321H13.6792C13.6474 18.2131 13.4908 18.3548 13.2952 18.3548H10.7014C10.5054 18.3548 10.3492 18.2131 10.3173 18.0321H2V18.3548H2.00344L3.00314 19H21.0003L22 18.3548H21.9966L21.9969 18.0321Z",
    fill: "#565555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5018 5.5162C20.5018 5.23229 20.2768 5 20.0018 5H4.00782C3.73282 5 3.50781 5.23229 3.50781 5.5162V17.3869C3.50781 17.3869 20.5434 17.3869 20.5018 17.3869V5.5162ZM15.5586 7.38807C16.5511 7.38807 17.3558 8.21883 17.3558 9.24349C17.3558 10.2681 16.5511 11.0989 15.5586 11.0989C14.5661 11.0989 13.7614 10.2681 13.7614 9.24349C13.7614 8.21883 14.5661 7.38807 15.5586 7.38807ZM9.71666 7.15578H10.3232V11.4686H9.71666V7.15578ZM8.73102 7.71844H9.33759V11.469H8.73102V7.71844ZM7.74507 8.56243H8.35164V11.469H7.74507V8.56243ZM6.75943 9.40609H7.366V11.469H6.75943V9.40609ZM10.3623 13.7967L10.111 13.5234L8.70852 15.2511L7.15256 13.5347L5.5866 15.4627L5.34722 15.2553L7.13943 13.0482L8.69539 14.7646L9.89416 13.2882L9.63291 13.004L10.6292 12.7136L10.3623 13.7967ZM18.659 15.2124H12.4586C12.4586 15.204 12.4586 15.0733 12.4586 13.5699C12.4586 11.8306 14.2864 11.8093 14.2864 11.8093H16.8311C16.8311 11.8093 18.659 11.8409 18.659 13.5699C18.659 15.073 18.659 15.2037 18.659 15.2124Z",
    fill: "#565555"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActivity);
export default __webpack_public_path__ + "static/media/user-activity.e86ccb5f49e058b712f053e75acc787c.svg";
export { ForwardRef as ReactComponent };